import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const LineItemContent = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { body , children , className , title  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "body",
        "children",
        "className",
        "title"
    ]);
    let content = children;
    if (!content) {
        content = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest",
            className: "elements-line-item-content__title"
        }, title), /*#__PURE__*/ React.createElement("div", {
            className: "elements-line-item-content__body"
        }, body));
    }
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item-content', className),
        ref: ref
    }), content);
});
LineItemContent.displayName = 'LineItemContent';

export { LineItemContent as default };
//# sourceMappingURL=LineItemContent.js.map
